import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { TrendingUp } from 'lucide-react';

const ElevationChart = ({ elevationProfile, distance, elevationGain }) => {
  // Guarda defensiva: aceita apenas arrays com objectos {distance, elevation}
  // válidos. Sem isto, Recharts crasha com "e.map is not a function" quando
  // o backend devolve null/objecto (aconteceu em rotas re-enriquecidas com
  // formato inconsistente).
  if (!Array.isArray(elevationProfile) || elevationProfile.length === 0) {
    return null;
  }
  const safeData = elevationProfile.filter(
    (p) => p && typeof p === 'object' && Number.isFinite(p.distance) && Number.isFinite(p.elevation),
  );
  if (safeData.length === 0) {
    return null;
  }

  return (
    <Card className="border-border shadow-sm" data-testid="elevation-chart">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-semibold flex items-center">
          <TrendingUp className="h-5 w-5 text-secondary mr-2" />
          Perfil de Elevação
        </CardTitle>
        <CardDescription>
          {distance && `Distância total: ${distance} km`}
          {elevationGain && ` • Ganho: ${elevationGain} m`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={200}>
          <AreaChart
            data={safeData}
            margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="elevationGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="hsl(30, 53%, 36%)" stopOpacity={0.8} />
                <stop offset="95%" stopColor="hsl(30, 53%, 36%)" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis
              dataKey="distance"
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              label={{ value: 'Distância (km)', position: 'insideBottom', offset: -5, fontSize: 11 }}
            />
            <YAxis
              stroke="hsl(var(--muted-foreground))"
              fontSize={12}
              tickLine={false}
              axisLine={false}
              label={{ value: 'Elevação (m)', angle: -90, position: 'insideLeft', fontSize: 11 }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'hsl(var(--popover))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
                padding: '8px 12px',
              }}
              labelStyle={{ color: 'hsl(var(--foreground))', fontWeight: 600 }}
              formatter={(value) => [`${value} m`, 'Elevação']}
              labelFormatter={(value) => `${value} km`}
            />
            <Area
              type="monotone"
              dataKey="elevation"
              stroke="hsl(30, 53%, 36%)"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#elevationGradient)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default ElevationChart;
